<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate height="2" />
    <SoDataIterator v-else :items="conversation">
      <template #default="{ item }">
        <SoMessage
          :html="item?.html"
          :subject="item?.subject"
          :is-receiver="!item.isIncoming"
          :is-private="item.isPrivate"
          :date="new Date(item.createdDate)"
          :to="item.toEmails"
          :from="item.fromEmail"
        >
          <template #attachments>
            <FreshdeskAttachment
              v-for="(attachment, index) in item.attachments"
              :key="index"
              :attachment="attachment"
            />
          </template>
        </SoMessage>
      </template>
    </SoDataIterator>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDataIterator from "@/components/SoDataIterator.vue"
  import SoMessage from "@/components/SoMessage.vue"
  import FreshdeskAttachment from "./FreshdeskAttachment.vue"
  import { IFreshdeskConversation } from "@/models/freshdeskThreadConversation/freshdeskThreadConversation.types"

  export default defineComponent({
    components: {
      SoDataIterator,
      SoMessage,
      FreshdeskAttachment,
    },
    inheritAttrs: false,
    props: {
      conversation: {
        type: Array as PropType<IFreshdeskConversation[]>,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  })
</script>
